module.exports = __webpack_public_path__ + "img/logo.7122717e.png";